import React from 'react';
import { useTranslation } from 'react-i18next';

const ClubRenewLevel =({}) => {
    const { t } = useTranslation();
    return (
        <div className={`clubRenewLevel`}>
            <div className="renewText">
           { t('clubRatingIsExpired')}
            </div>
           <div class="dialogConfirmBox"><button class="primary">{t('renew')}</button></div>
        </div>
    );
};

export default ClubRenewLevel;
